import { createAuthenticatedClient } from '@/platform/auth/api/authenticatedClient'
import { platformEnv } from '@/platform/config/env'

const paymentClient = createAuthenticatedClient(platformEnv.paymentApiUrl)

export default paymentClient
